import { render, staticRenderFns } from "./Headphones.vue?vue&type=template&id=4bc71300&scoped=true"
import script from "./Headphones.vue?vue&type=script&lang=js"
export * from "./Headphones.vue?vue&type=script&lang=js"
import style0 from "./Headphones.vue?vue&type=style&index=0&id=4bc71300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc71300",
  null
  
)

export default component.exports